import React from 'react';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import styles from './PrivacyButton.module.scss';

interface ButtonProps {
  children: React.ReactNode;
  className?: string | null;
  hasInitialFocus?: boolean;
  focusId?: string | number | null;
  onClick?: () => void;
  onFocusSet?: (value: boolean) => void;
  ttsText: string;
  type?: 'button' | 'submit' | 'reset';
}

const Button = ({
  children,
  className = null,
  hasInitialFocus = false,
  focusId = null,
  onClick = () => {},
  onFocusSet = () => {},
  ttsText,
  ...rest
}: ButtonProps) => {
  return (
    <Selectable
      onSelect={onClick}
      hasInitialFocus={hasInitialFocus}
      focusId={focusId}
      onFocusSet={onFocusSet}
      ttsText={ttsText}
      render={({ hasFocus }) => (
        <button
          type="button"
          className={classNames(
            styles.button,
            className,
            hasFocus ? styles.focused : styles.unfocused,
          )}
          onClick={onClick}
          {...rest}
        >
          {children}
        </button>
      )}
    />
  );
};

export default React.memo(Button);
